// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ninetales_alola: PokeData = {
  "id": 10104,
  "name": "ninetales-alola",
  "height": 11,
  "weight": 199,
  "base_experience": 177,
  "types": [
    PokeType.ICE,
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "disable",
    "mist",
    "ice-beam",
    "blizzard",
    "aurora-beam",
    "hypnosis",
    "confuse-ray",
    "spite",
    "powder-snow",
    "icy-wind",
    "safeguard",
    "imprison",
    "grudge",
    "extrasensory",
    "sheer-cold",
    "nasty-plot",
    "ice-shard",
    "dazzling-gleam",
    "aurora-veil"
  ],
  "moves": [
    "tackle",
    "blizzard",
    "confuse-ray",
    "sheer-cold",
    "ice-shard",
    "dazzling-gleam",
    "aurora-veil",
    "starfall",
    "ice-fang",
    "moonlight",
    "guardian-bond",
    "moonblast",
    "hailstorm"
  ],
  "evolution_chain": {
    "id": 15,
    "item": null,
    "species": [
      {
        "name": "vulpix",
        "order": 39,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ninetales",
        "order": 40,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 37,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 119,
    "speed": 161,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
